import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import LandingJazzCashScreen from "../../JazzCash/screen/LandingJazzCashScreen";
import JazzCashFallbackScreen from "../screen/JazzCashFallBackScreen";
// import TriviaScreen from "../screen/TriviaScreen";
const LandingJazzCashRoutes = () => {
  //incase of in valid route redirect to main app
  const RedirectToMainApp = ({ to }: { to: string }) => {
    useEffect(() => {
      window.location.replace(to);
    }, []);
    return <></>;
  };
  return (
    <div className="App">
      <Routes>
        <Route path="/landing" element={<LandingJazzCashScreen />} />
        <Route path="/jc" element={<JazzCashFallbackScreen />} />
        <Route path="/*" element={<RedirectToMainApp to="/home" />} />
      </Routes>
    </div>
  );
};

export default LandingJazzCashRoutes;
